
















































































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import VueMultiselect from 'vue-multiselect/src/Multiselect.vue'
import {PropType} from 'vue'
import {TokensTableItem} from '@/model/resource/TokensTableItem'

@Component({
  components: {
    VueMultiselect,
  },
})
export default class SwapSelectToken extends Vue {
  @Prop({type: Array, required: true}) options!: TokensTableItem[]
  @Prop({type: Object as PropType<TokensTableItem | null>})
  token!: TokensTableItem | null
  @Prop({type: String, required: true}) title!: string

  handleSelect(val: TokensTableItem) {
    this.$emit('select', val)
  }

  focusOnInput() {
    const input = this.$el.querySelector(
      '.swap-select-token__input'
    ) as HTMLInputElement
    input.focus()
  }
}
